import moment from 'moment'

const Utils = {
  formatMoney: function (val) {
    return '$' + (val).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
  },
  states: function () {
    return [
      'Alabama', 
      'Alaska', 
      'Arizona', 
      'Arkansas', 
      'California', 
      'Colorado', 
      'Connecticut', 
      'Delaware', 
      'District of Columbia', 
      'Florida', 
      'Georgia', 
      'Hawaii', 
      'Idaho', 
      'Illinois', 
      'Indiana', 
      'Iowa', 
      'Kansas', 
      'Kentucky', 
      'Louisiana', 
      'Maine', 
      'Maryland', 
      'Massachusetts', 
      'Michigan', 
      'Minnesota', 
      'Mississippi', 
      'Missouri', 
      'Montana', 
      'Nebraska', 
      'Nevada', 
      'New Hampshire', 
      'New Jersey', 
      'New Mexico', 
      'New York', 
      'North Carolina', 
      'North Dakota', 
      'Ohio', 
      'Oklahoma', 
      'Oregon', 
      'Pennsylvania', 
      'Rhode Island', 
      'South Carolina', 
      'South Dakota', 
      'Tennessee', 
      'Texas', 
      'Utah', 
      'Vermont', 
      'Virginia', 
      'Washington', 
      'West Virginia', 
      'Wisconsin', 
      'Wyoming'
    ];
  },

  findFieldValue(listing, fieldName) {
    var value = "";
    listing.fields.forEach(field => {
      if (field.name == fieldName) {
        if(field.type == 'Date'){
          value = moment(field.value).format("MM/DD/YYYY")
        }else if(field.type == 'Website'){
          value = field.value
          if(!value.includes('http://') && !value.includes('https://') && value.length > 1){
            value = 'http://' + value
          }
        }else if(field.type == 'Y/N'){
          value = field.value == 'Y' ? 'Yes' : 'No'
        }else if(field.type == 'Multi Select Dropdown'){
          value = field.value.split(',').join(', ');
        }else{
          value = field.value;
        }
        
      }
    });
    return value;
  },
  formatDate(date){
    if(!date){
      return "";
    }
    return moment(date).format("MM/DD/YYYY");
  },
  randomString(length) {
    var result           = [];
    var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var charactersLength = characters.length;
    for ( var i = 0; i < length; i++ ) {
      result.push(characters.charAt(Math.floor(Math.random() * 
 charactersLength)));
   }
   return result.join('');
}

  
}

export default Utils



// WEBPACK FOOTER //
// ./src/Utils/Utils.js